import {css, Flex} from "@dna/react";
import {Input, InputAdornment} from "@material-ui/core";
import React, {useCallback, useEffect, useState} from "react";
import close from "../../images/close.png";
import {logger} from "../common/logger";

function debounce(func:any, wait:number, immediate?:any) {
    let timeout:any;
    return function(this:void,...args:any[]) {
        clearTimeout(timeout);
        timeout = setTimeout(function(this:void) {
            timeout = null;
            if (!immediate) func.apply(this, args);
        }, wait);
        if (immediate && !timeout) func.apply(this, args);
    };
}


function CloseIcon() {
    return (
        <div className={css({
            width: 16.67,
            height: 16.67,
            left: "8.33%",
            right: "8.33%",
            top: "8.33%",
            bottom: "8.33%"

        })} >
            <img src={close} />
        </div>
    )
}

function NameClearButton(props: { name:string|null|undefined, handleClear: any }) {

    if (!props.name) {
        return <div/>
    }
    return (

        <button className={css({
            border: "none",
            outline: "none",
            cursor: "pointer",
            backgroundColor: "transparent",
        })}
                onClick={() => props.handleClear("name")}>
            <CloseIcon />
        </button>
    )
}

export function ResidentNameInput(props: {name:string, handleChange: (newName:string)=>void
     }) {

    let [state, setName] = useState(props.name);
    
    const invoker = useCallback (debounce((val:string)=>{
            logger.log('Debounced invocation',val);
            props.handleChange(val);
        },300),[]);
    
    const nameChanged = (event:any)=>{
        let newName = event?.target?.value||'';
        setName(newName);
        if (invoker){
            invoker(newName);    
        }
        
    };
    
    return (
        <Flex css={{
            backgroundColor: "grey-100",
            width: "100%"
        }}>
            <Input onChange={nameChanged}
                   value={state}
                   name="name"
                   style={{ width: "100%" }}
                   endAdornment={
                       <InputAdornment position="end">
                           <NameClearButton name={state} handleClear={nameChanged}/>
                       </InputAdornment>
                   }
            />
        </Flex>
    );
}